import { createIsomorphicFn } from '@tanstack/react-start';
import { getRequestHeader } from '@tanstack/react-start/server';
import { isMobile } from '@/utils/isMobile';
import type { Device } from '../types';

// Resolve the web/mweb variant from the client's User-Agent — ISOMORPHIC (the
// getAuth pattern) so the route loader can call it on both sides:
//   SSR        → the request's User-Agent header, so the CORRECT variant is in
//                the initial HTML (mobile-first indexing; no client-side
//                variant flip after hydration).
//   client nav → navigator.userAgent via the app-wide isMobile() helper — the
//                same client the server classified, so the answer can't drift.
// The UA classification itself is @/utils/isMobile (shared with
// manage-payments) — one regex set for the whole app.
//
// Call it in the LOADER, not at render: the resolved value rides the
// dehydrated loader data, so hydration reuses the server's answer verbatim.
export const resolveDevice = createIsomorphicFn()
	.server(
		(): Device =>
			isMobile(getRequestHeader('User-Agent') ?? '') ? 'mweb' : 'web',
	)
	.client((): Device => (isMobile() ? 'mweb' : 'web'));
